import React, { useRef, useState } from "react";
import { Tooltip } from "./Tooltip";
import { useOnClickOutside } from "../../DateRange/outside";

export const IncorrectWord = ({
  word,
  error,
  onWordReplace,
  onIgnoreClick
}) => {
  const tooltip = useRef();

  const [isToggled, setIsToggled] = useState(false);

  const handleToggle = () => setIsToggled(prevState => !prevState);

  useOnClickOutside(tooltip, () => setIsToggled(false));

  const handleChipClick = chip => () => onWordReplace(word, chip);

  const handleIgnoreClick = () => {
    onIgnoreClick();
    handleToggle();
  };

  return (
    <span className="spell-checker-incorrect-word" ref={tooltip}>
      <span
        onClick={handleToggle}
        className={`spell-checker__word spell-checker__word_incorrect spell-checker__word_${error.ui.tag}`}
      >
        {word}
      </span>
      {isToggled && (
        <Tooltip
          error={error}
          onChipClick={handleChipClick}
          onIgnoreClick={handleIgnoreClick}
        />
      )}
    </span>
  );
};
